<script setup>
import { binder } from '..'
const model = defineModel()
</script>
<template>
  <textarea v-model="model" v-bind="binder" class="form-control" />
</template>
